import { gql } from 'apollo-boost';

export const updateRetargetingMutation = gql`
    mutation UpdateRetargetingConditionsMutation($input: GdUpdateRetargetingConditionsInput!) {
        reqId: getReqId
        updateRetargetingConditions(input: $input) {
            rowset {
                retargetingConditionId
            }
            validationResult {
                errors {
                    path
                    params
                    code
                }
            }
        }
    }
`;

export const createRetargetingMutation = gql`
    mutation CreateRetargetingConditionsMutation($input: GdCreateRetargetingConditionsInput!) {
        reqId: getReqId
        createRetargetingConditions(input: $input) {
            rowset {
                retargetingConditionId
            }
            validationResult {
                errors {
                    path
                    params
                    code
                }
            }
        }
    }
`;

export const retargetingCommonPriceEditorMutation = gql`
    mutation RetargetingCommonPriceEditorMutation($input: GdSetBidsInput!, $login: String!) {
        reqId: getReqId
        setBidsRetargeting(input: $input) {
            showConditionIds
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;

export const resumeRetargetings = gql`
    mutation ResumeRetargetingsMutation($input: GdResumeRetargetingsInput!, $login: String!) {
        reqId: getReqId
        resumeRetargetings(input: $input) {
            successCount
            totalCount
            rowset {
                retargetingId
            }
            validationResult {
                errors {
                    path
                    code
                    params
                }
                warnings {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;

export const suspendRetargetings = gql`
    mutation SuspendRetargetingsMutation($input: GdSuspendRetargetingsInput!, $login: String!) {
        reqId: getReqId
        suspendRetargetings(input: $input) {
            successCount
            totalCount
            rowset {
                retargetingId
            }
            validationResult {
                errors {
                    path
                    code
                    params
                }
                warnings {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;

export const deleteRetargetings = gql`
    mutation DeleteRetargetingsMutation($input: GdDeleteRetargetingsInput!, $login: String!) {
        reqId: getReqId
        deleteRetargetings(input: $input) {
            successCount
            totalCount
            rowset {
                retargetingId
            }
            validationResult {
                errors {
                    path
                    code
                    params
                }
                warnings {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;
